// React Imports
import * as React from "react";
import {useDispatch, useSelector} from "react-redux";


// Mui Imports
import MenuItem from "@mui/material/MenuItem";
import {
    ListItemIcon,
    ListItemText,
    Tooltip
} from "@mui/material";

// App Imports
import Box from "@mui/material/Box";
import {changeExpense} from "../../WorkIssuanceExpense/expenseSlice";

import {KeyboardReturn} from "@mui/icons-material";
import {changeWorkIssuance} from "../../workIssuanceSlice";


// main function
export default function RemittedExpense({ onMenuClose, rowCdpStatus, showOwed, showExpense }) {

    // ****************** BEGIN DISPATCH ****************************

    const dispatchData = useDispatch();

    // ****************** END DISPATCH ****************************

    const handleRemitted = () => {
        // dispatchData(changeExpense({rejectedState: true, expenseNewStatus: '2359'}));
        dispatchData(changeWorkIssuance({newStatus:  '4553', updateCdpStatus: true}));
        onMenuClose();
    };



    return (

        <Box>
            {(
                    // rowCdpStatus === "2351" ||  rowCdpStatus === "2359"
                    (rowCdpStatus === "2359" && showExpense === true)
                ) &&
                <MenuItem onClick={handleRemitted}>
                    <ListItemIcon>
                        <KeyboardReturn fontSize="small" />
                    </ListItemIcon>
                    <ListItemText>Remitted</ListItemText>
                </MenuItem>
            }
        </Box>

    )

}
